export const convertDerivedValueToDisplay = (
  value: unknown,
): string | number => {
  if (typeof value == 'string') {
    return value
  } else if (typeof value == 'number') {
    return value
  } else {
    return JSON.stringify(value)
  }
}
